'use strict';
import util from './util';



var recaptcha = {
    /* source name, may only include "A-Za-z/_". Do not include user-specific information*/	
    source: {
        CONTACT_US: 'contactus',
    },

    getGoogleRecaptchaEnableStatus: function(source) {
        var isRecaptchaEnabled = SitePreferences.RECAPTCHA_ENABLED;
        
        if (!isRecaptchaEnabled) {
        	return false;
        }

        if (source === this.source.CONTACT_US) {
            isRecaptchaEnabled = SitePreferences.RECAPTCHA_FOR_CONTACTUS_ENABLED;
        } else {
            isRecaptchaEnabled = false;
        }

        return isRecaptchaEnabled;
    },
    
    generateRecaptchaToken: function(event, source, callbackFun) {
    	if (this.getGoogleRecaptchaEnableStatus(source) === true && SitePreferences.RECAPTCHA_SITE_KEY != null && typeof grecaptcha === 'object') {
    		event.preventDefault();
            event.stopPropagation();
    		grecaptcha.execute(SitePreferences.RECAPTCHA_SITE_KEY, {action: source}).then(callbackFun);
            return false;
    	}
    },
    
    displayRecaptchaError: function(msg) {
        if($('.grecaptcha-badge').length > 0  && !$('.send-contact-us').hasClass('invalidrecaptcha')) {
            var $errEle = $('<div class="grecaptcha-error">' + '' + '</div>');
            $errEle.html(msg).insertBefore('.send-contact-us');
            $('.send-contact-us').addClass('invalidrecaptcha'); 
        }
    }
};

export default recaptcha;
